export const LIST_FUNCTIONALITIES_BY_PURPOSE_ID_REQUEST = 'LIST_FUNCTIONALITIES_BY_PURPOSE_ID_REQUEST';
export const LIST_FUNCTIONALITIES_BY_PURPOSE_ID_REQUEST_SUCCESS = 'LIST_FUNCTIONALITIES_BY_PURPOSE_ID_REQUEST_SUCCESS';
export const LIST_FUNCTIONALITIES_BY_PURPOSE_ID_REQUEST_FAILURE = 'LIST_FUNCTIONALITIES_BY_PURPOSE_ID_REQUEST_FAILURE';

export const CLEAR_FUNCTIONALITIES_LIST_BY_PURPOSE_ID = 'CLEAR_FUNCTIONALITIES_LIST_BY_PURPOSE_ID';